import React from "react";
import PropTypes from "prop-types";
import { H1, P } from "orcs-design-system";

import { copywriting } from "src/components/ErrorPage/ErrorPage.config";
import ErrorPageWrapper from "./ErrorPageWrapper";
import SupportErrorDetails from "./SupportErrorDetails";

const ServerError = ({ supportErrorDetails, showHeader, showContainer }) => {
  return (
    <ErrorPageWrapper showHeader={showHeader} showContainer={showContainer}>
      <H1>{copywriting.serverErrorHeading}</H1>
      <P>{copywriting.serverErrorDetail}</P>
      <SupportErrorDetails details={supportErrorDetails} />
    </ErrorPageWrapper>
  );
};

ServerError.propTypes = {
  supportErrorDetails: PropTypes.string,
  showHeader: PropTypes.bool,
  showContainer: PropTypes.bool,
};

export default ServerError;
